import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-3ec68f27"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mb-md-10 d-flex align-items-center justify-content-between" }, [
  /*#__PURE__*/_createElementVNode("h6", { class: "card-title fw-bold mb-0" }, "Unique SKUs Retrieved per day - with percentile analysis")
], -1))
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-lg-9 col-xxxl-10 col-md-10" }
const _hoisted_5 = {
  id: "skuVariabilityChart",
  class: "chart"
}
const _hoisted_6 = { class: "col-lg-3 col-xxxl-2 col-md-2" }
const _hoisted_7 = { class: "list ps-0 mb-0 mt-15 mt-md-25 list-unstyled" }
const _hoisted_8 = { class: "d-flex align-items-center mb-5" }
const _hoisted_9 = { class: "fs-12 fw-medium text-black-emphasis text-uppercase lh-1 ms-8" }
const _hoisted_10 = { class: "mb-0 fw-black" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_apexchart, {
            type: "bar",
            height: "325",
            options: _ctx.chartOptions,
            series: _ctx.chartData
          }, null, 8, ["options", "series"])
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("ul", _hoisted_7, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.labels, (label, index) => {
            return (_openBlock(), _createElementBlock("li", { key: index }, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("span", {
                  class: _normalizeClass(['d-block w-10 h-10 rounded-circle', label.colorClass])
                }, null, 2),
                _createElementVNode("span", _hoisted_9, _toDisplayString(label.name) + " (" + _toDisplayString(label.equation) + ") ", 1)
              ]),
              _createElementVNode("h4", _hoisted_10, _toDisplayString(label.minValue), 1)
            ]))
          }), 128))
        ])
      ])
    ])
  ]))
}